import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const Payment = ({ project, onNext, onBack, currentStatus, tracer }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("PAYMENT", { returnObjects: true });

  const onSubmit = () => onNext({ payload: {} });

  return (
    <>
      <Navbar
        project={project}
        currentStatus={currentStatus}
        tracer={tracer}
        showProfile
        showCart
      />
      <View translate={TRANSLATION} onNext={onSubmit} onBack={onBack} />
    </>
  );
};

export default Payment;
